'use strict';
exports = module.exports = {
 publicDocumentation: [{"space":"PD","title":"Getting Started","items":[{"title":"Login to Syncplicity account","id":"login_to_syncplicity_account"}],"name":"getting_started","filename":"getting_started.html","id":"186482689","version":{"when":"2025-09-02T15:37:52.874Z","number":5}}]}


//////////////////
// WEBPACK FOOTER
// ./server/config/environment/publicDocumentation/publicDocumentationShared.js
// module id = 275
// module chunks = 0